(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AvpgComLib", [], factory);
	else if(typeof exports === 'object')
		exports["AvpgComLib"] = factory();
	else
		root["AvpgComLib"] = factory();
})(window, function() {
return 